<template>
  <div>
    <HttpSelectInputView v-if="type.inputType === 'select' && type.searchable" size="small" :errors="errors" :endpoint="utilities.path('communities/@/modules/automation/data/types/@/search', communityId, type.key)" :value="value" @update:value="updateValue($event)">
      <template v-slot:option="{ option }">
        {{ option.title }}
      </template>
    </HttpSelectInputView>
    <FilteredSelectInputView v-else-if="type.inputType === 'select' && type.options" :filter="({ query, item }) => item.title.toLowerCase().includes(query.toLowerCase())" size="small" :errors="errors" required :value="value" @update:value="updateValue($event)" :options="type.options">
      <template v-slot:option="{ option }">
        {{ option.title }}
      </template>
    </FilteredSelectInputView>
    <InputView type="text" v-else-if="type.inputType === 'text'" size="small" :errors="errors" :value="value" @update:value="updateValue($event)"/>
    <DatePickerView v-else-if="type.inputType === 'datetime'" :errors="errors" time :value="value && typeof value === 'string' ? value : undefined" @update:value="updateValue($event)">
      <template v-slot:target="{ toggle }">
        <ButtonView type="normal" color="secondary" @click="toggle" size="small">
          {{ value ? utilities.formatDatetime(value) : "" }}
        </ButtonView>
      </template>
    </DatePickerView>
    <SelectInputView v-else-if="type.inputType === 'checkbox'" size="small" required :value="value" :errors="errors" @update:value="updateValue($event)" :options="[{title: translate('yes'), id: true}, {title: translate('no'), id: false}]">
      <template v-slot:option="{ option }">
        {{ option.title }}
      </template>
    </SelectInputView>
  </div>
</template>

<script>
import {InputView, HttpSelectInputView, FilteredSelectInputView, ButtonView, utilities, DatePickerView, SelectInputView} from "@/niftybit";

export default {
  name: "AutomationValueInput",
  computed: {
    utilities() {
      return utilities
    }
  },
  props: {
    communityId: String,
    type: Object,
    value: [String, Number, Boolean],
    errors: Array
  },
  emits: ["update:value"],
  components: {ButtonView, DatePickerView, SelectInputView, HttpSelectInputView, FilteredSelectInputView, InputView},
  methods: {
    updateValue(value) {
      this.$emit("update:value", value);
    }
  }
}
</script>